import React, { useContext, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faAddressCard, faLanguage, faE, faBus, faPen, faEye, faSync, faTimes, faBuildingCircleCheck, faCalendarWeek } from '@fortawesome/free-solid-svg-icons';
import CountUp from 'react-countup';
import { Card, Row, Col, OverlayTrigger, Tooltip, Button, Form } from "react-bootstrap";
import { CSSTransition } from 'react-transition-group';
import ChartsContext from "contexts/ChartsContext";
import TodayRegistration from "./DetailsTable/TodayRegistration";
import CheckinTable from "./DetailsTable/CheckinTable";
import Papa from 'papaparse';
import { useHistory } from 'react-router-dom';


function DataSnapshots({ onRefresh }) {
    const [showCheckinTable, setShowCheckinTable] = useState(false);
    const [showTotalToday, setShowTotalToday] = useState(false);

    const history = useHistory();

    const handleFullListDetailsClick = () => {
        history.push('/admin/eventregadmin');
    };
    const {
        updateTime,
        totalEntries,
        totalToday,
        checkIns,
        totalHeadCount,
        checkInGroupSizeTotal
    } = useContext(ChartsContext);

    // Debug: Log context values
    React.useEffect(() => {
        console.log("DataSnapshots - Context Values:", {
            totalEntries,
            totalToday,
            totalHeadCount,
            checkInGroupSizeTotal,
            checkIns
        });
    }, [totalEntries, totalToday, totalHeadCount, checkInGroupSizeTotal, checkIns]);

    const handleCSVDownload = (data, filename) => {
        // Define the column order
        const columnOrder = [
            'id',
            'firstname',
            'lastname',
            'chinesename',
            'email',
            'phone',
            'checkedIn',
            'lastNotificationSent',
            'checkedInTime',
            'registrationTime'
        ];


        // Use PapaParse to unparse the data with the specified columns
        const csv = Papa.unparse({
            fields: columnOrder,
            data: data.map(row => columnOrder.reduce((obj, key) => ({ ...obj, [key]: row[key] }), {}))
        }, {
            quotes: false, // Quote all fields
            quoteChar: '"',
            escapeChar: '"',
            delimiter: ",",
            header: true,
            newline: "\r\n",
            skipEmptyLines: false, // Skip empty lines
            columns: columnOrder // Ensure the columns are in the correct order
        });

        // Create a Blob from the CSV String with UTF-8 BOM to ensure proper display of Chinese characters
        const BOM = "\uFEFF";
        const csvBlob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' });

        const csvUrl = URL.createObjectURL(csvBlob);
        const downloadLink = document.createElement('a');
        downloadLink.href = csvUrl;
        downloadLink.setAttribute('download', `${filename}.csv`);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };


    const handleTableClose = (table) => {
        if (table === 'checkin') {
            setShowCheckinTable(false);
        }
        else if (table === 'totalToday') {
            setShowTotalToday(false);
        }
    };

    const handleDetailsButtonClick = (table) => {
        setShowCheckinTable(table === 'checkin');
        setShowTotalToday(table === 'totalToday');
    };

    const eventLabel = '清明法會';

    return (
        <div style={{ width: '100%' }}>

            <Row>
                {/* Total Registrations Card */}
                <Col lg="4" sm="6">
                    <div className="card-container">
                        <Card className="card-stats">
                            <Card.Body>
                                <Row>
                                    <Col xs="5">
                                        <div className="icon-big text-center icon-warning">
                                            <span className="text-info">報名</span>
                                        </div>
                                    </Col>
                                    <Col xs="7">
                                        <div className="numbers">
                                            <p className="card-category font-weight-bold"><span className="text-warning">{eventLabel}</span>總報名人數</p>
                                            <Card.Title as="h2" className="font-weight-bold text-dark">
                                                <CountUp end={totalEntries || 0} duration={2.75} />
                                                <span className="h6"> 人</span>
                                            </Card.Title>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                            <Card.Footer>
                                <hr />
                                <div className="stats">
                                    <i className="fas fa-redo mr-1"></i>
                                    Updated at <span className="font-weight-bold">{updateTime}</span>
                                </div>
                            </Card.Footer>
                        </Card>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
                            <Button className="btn-round btn-outline details-button" variant="twitter" onClick={handleFullListDetailsClick}>
                                <FontAwesomeIcon icon={faEye} />
                            </Button>
                        </OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
                            <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                                <FontAwesomeIcon icon={faSync} />
                            </Button>
                        </OverlayTrigger>
                    </div>
                </Col>

                {/* Today's registration Card */}
                <Col lg="4" sm="6">
                    <div className="card-container">
                        <Card className="card-stats">
                            <Card.Body>
                                <Row>
                                    <Col xs="5">
                                        <div className="icon-big text-center icon-warning">
                                            <span className="text-success">今日</span>
                                        </div>
                                    </Col>
                                    <Col xs="7">
                                        <div className="numbers">
                                            <p className="card-category font-weight-bold">{eventLabel}<span className="text-warning">今日</span>報名人數</p>
                                            <Card.Title as="h2" className="font-weight-bold text-dark">
                                                <CountUp end={totalToday || 0} duration={2.75} />
                                                <span className="h6"> 人</span>
                                            </Card.Title>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                            <Card.Footer>
                                <hr />
                                <div className="stats">
                                    <i className="fas fa-redo mr-1"></i>
                                    Updated at <span className="font-weight-bold">{updateTime}</span>
                                </div>
                            </Card.Footer>
                        </Card>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
                            <Button className="btn-round btn-outline details-button" variant="twitter" onClick={() => handleDetailsButtonClick('totalToday')}>
                                <FontAwesomeIcon icon={faEye} />
                            </Button>
                        </OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
                            <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                                <FontAwesomeIcon icon={faSync} />
                            </Button>
                        </OverlayTrigger>
                    </div>
                </Col>

                {/* Check-in Card */}
                <Col lg="4" sm="6">
                    <div className="card-container">
                        <Card className="card-stats">
                            <Card.Body>
                                <Row>
                                    <Col xs="5">
                                        <div className="icon-big text-center icon-warning">
                                            <span className="text-body">簽到</span>
                                        </div>
                                    </Col>
                                    <Col xs="7">
                                        <div className="numbers">
                                            <p className="card-category font-weight-bold">{eventLabel}<span className="text-warning">簽到</span>總人數</p>
                                            <Card.Title as="h2" className="font-weight-bold text-dark">
                                                <CountUp end={checkInGroupSizeTotal || 0} duration={2.75} />
                                                <span className="h6"> 人</span>
                                            </Card.Title>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                            <Card.Footer>
                                <hr />
                                <div className="stats">
                                    <i className="fas fa-redo mr-1"></i>
                                    Updated at <span className="font-weight-bold">{updateTime}</span>
                                </div>
                            </Card.Footer>
                        </Card>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
                            <Button className="btn-round btn-outline details-button" variant="twitter" onClick={() => handleDetailsButtonClick('checkin')}>
                                <FontAwesomeIcon icon={faEye} />
                            </Button>
                        </OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
                            <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                                <FontAwesomeIcon icon={faSync} />
                            </Button>
                        </OverlayTrigger>
                    </div>
                </Col>
            </Row>

            <Row>
                {/* Total Participants Card */}
                <Col lg="8" sm="6">
                    <div className="card-container">
                        <Card className="card-stats">
                            <Card.Body>
                                <Row>
                                    <Col xs="5">
                                        <div className="icon-big text-center icon-warning">
                                            <span className="text-danger">預計到場</span>
                                        </div>
                                    </Col>
                                    <Col xs="7">
                                        <div className="numbers">
                                            <p className="card-category font-weight-bold">{eventLabel}<span className="text-danger">預計到場</span>總人數</p>
                                            <Card.Title as="h2" className="font-weight-bold text-dark">
                                                <CountUp end={totalHeadCount || 0} duration={2.75} />
                                                <span className="h6"> 人</span>
                                            </Card.Title>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                            <Card.Footer>
                                <hr />
                                <div className="stats">
                                    <i className="fas fa-redo mr-1"></i>
                                    Updated at <span className="font-weight-bold">{updateTime}</span>
                                </div>
                            </Card.Footer>
                        </Card>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
                            <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                                <FontAwesomeIcon icon={faSync} />
                            </Button>
                        </OverlayTrigger>
                    </div>
                </Col>
            </Row>



            <CSSTransition in={showCheckinTable} timeout={300} classNames="table-transition" unmountOnExit>
                <Row>
                    <Col md="12">
                        <CheckinTable handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('checkin')} />
                    </Col>
                </Row>
            </CSSTransition>

            <CSSTransition in={showTotalToday} timeout={300} classNames="table-transition" unmountOnExit>
                <Row>
                    <Col md="12">
                        <TodayRegistration handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('totalToday')} />
                    </Col>
                </Row>
            </CSSTransition>
        </div>
    );
}

export default DataSnapshots;
